import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';

export const autosendDisabledScenarios = [
  SCENARIO_STEP.CREDIT_SELECTION,
  SCENARIO_STEP.BANKS_REFUSED,
  SCENARIO_STEP.PRODUCT_ISSUED,
];
